import { render, staticRenderFns } from "./UiHeaderUserLang.vue?vue&type=template&id=7c857274&"
import script from "./UiHeaderUserLang.vue?vue&type=script&lang=js&"
export * from "./UiHeaderUserLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports